import React, { useState, useEffect } from 'react';
import Joyride from 'react-joyride';
import { useLocation, useNavigate } from 'react-router-dom';
import { can_visit, getPractice, setSecureData } from '../../helpers';
import { updateUserTour } from '../../services/profile';
import { getPracticeInfo } from '../../Session';

const JoyRideSteps = ({ selectedPracticeChange, fetchChangePracticeData, tourType, setTourType }) => {
  let location_id = getPractice("location_id");
  let account_id = getPractice("account_id");
  let user_id = getPractice("user_id");
  if(selectedPracticeChange != null && fetchChangePracticeData){
    location_id = selectedPracticeChange?.location_id;
    account_id = selectedPracticeChange?.account_id;
  }

  const [steps, setSteps] = useState([]);
  const [isTourActive, setIsTourActive] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if(tourType === "automatic") {
      const portalTour = getPractice("tour_needed");
      if (portalTour === false) {
        setIsTourActive(false);
        return;
      }
    }
    if (can_visit('_role_trial')) {
      setIsTourActive(false);
      return;
    }

    const allSteps = [
      { target: '.docpro_toor_box1', content: 'See all your patient in waiting room from here' },
      { target: '.docpro_toor_box2', content: 'See all patients from centralized location with advanced filtering options' },
      { target: '.docpro_toor_box3', content: 'Click a row to view patients demographics, health history and outreach history from single pane' },
      { target: '.docpro_toor_box4', content: 'Close gaps in care  faster with our CareGap Plus feature with advanced filtering option' },
      { target: '.docpro_toor_box5', content: 'Filter patient and quality measures' },
      { target: '.docpro_toor_box6', content: 'Find your chronic care management notes faster here' },
      { target: '.docpro_toor_box7', content: 'Find the AI generated CCM Note from outreach calls' },
    ];

    setSteps(allSteps);
    setIsTourActive(true);
  }, [location]);

  const handleTourCallback = async (data) => {
    const { index, status, type } = data;

    if (status === 'finished' || status === 'skipped') {
      await updateTour();
    } else if (type === 'step:after') {
      if (location.pathname === '/' && index === 0) {
        setIsTourActive(false);
        navigate('/patient-database');
        setCurrentIndex(1);
      } else if (location.pathname === '/patient-database' && index === 2) {
        setIsTourActive(false);
        navigate('/caregap-plus');
        setCurrentIndex(3);
      } else if (location.pathname === '/caregap-plus' && index === 4) {
        setIsTourActive(false);
        navigate('/ccm-database');
        setCurrentIndex(5);
      }
    }
  };

  useEffect(() => {
    if (location.pathname === '/patient-database' && currentIndex === 2) {
      setIsTourActive(true);
    } else if (location.pathname === '/caregap-plus' && currentIndex === 4) {
      setIsTourActive(true);
    } else if (location.pathname === '/ccm-database' && currentIndex === 5) {
      setIsTourActive(true);
    }
  }, [location, currentIndex]);

  const updateTour = async () => {
    const updatedToutData = {
      account_id: account_id,
      location_id: location_id,
      user_id: user_id,
    }

    try {
      const response = await updateUserTour(updatedToutData);
      if(response){
        if (!response?.detail && response?.data?.status === "success") {
          setCurrentIndex(0);
          setIsTourActive(false);
          setTourType("automatic");

          const practiceInfo = getPracticeInfo() || {};
          practiceInfo.tour_needed = false;
          await setSecureData("practiceInfo", JSON.stringify(practiceInfo));
        }
      }
    } catch (error) {}
  };


  return (
    <div>
      <Joyride
        steps={steps}
        run={isTourActive}
        stepIndex={currentIndex % steps.length}
        continuous={true}
        scrollToFirstStep={true}
        showProgress={false}
        showSkipButton={true}
        callback={handleTourCallback}
        locale={{
          skip: "Skip",
          last:"Finish",
        }}
        styles={{
          options: {
            backgroundColor: '#f8f9fa',
            textColor: '#343a40',
            zIndex: 1000,
          },
          buttonBack: {
            display: 'none',
          },
          buttonClose: {
            display: 'none',
          },
          buttonSkip: {
            backgroundColor: '#a2a2a2',
            color: '#fff',
            border: 0,
            outline: 0,
            fontSize: '14px',
            borderRadius: '4px',
            padding: '8px 12px'
          },
          buttonNext: {
            backgroundColor: '#007bff',
            color: '#fff',
            border: 0,
            outline: 0,
            fontSize: '14px',
            borderRadius: '4px',
            padding: '8px 12px'
          },
        }}
      />
    </div>
  );
};

export default JoyRideSteps;
